import enLocale from "element-ui/lib/locale/lang/en"; //引入element语言包
//中文对应的英文
const en = {
  ...enLocale,
  message: {
    info: {
      userInfo: "userInfo",
    },
    table: {
      item_number: "item number",
    },
  },
};

export default en;
